<template>
  <div class="page">
    <Header :activeIndex="0" />
    <!-- about us -->
    <div class="about_box">
      <div class="w">
        <img class="title" src="../assets/images/home/about.png" />
        <div class="content">
          The Company established in 2015, is located in Dongguan, a famous machinery production base and an important foreign trade port in Guangdong Province,mainly engaged in the production and processing of various precision machinery parts. The whole company includes sales, finance, engineers and production staff of more than 50 people. The factory is 2500 square meters, annual capacity of about 50 million. The company is well equipped, with CNC, CNC lathes,common milling machines, automatic grinding machines and more than 40sets. After several years of development and improvement, the company has mature business model, perfect system, exquisite technology, strict requirementsfor product quality, think highly of customer service.
        </div>
      </div>
    </div>
    <!-- category -->
    <div class="category_box">
      <ul class="flex5 w">
        <li v-for="(item,index) in catList" :key="index" @click="toDetail(index)">
          <img :src="item.img" class="top" />
          <div class="bottom">
            <div class="name">{{item.name}}</div>
            <div class="detail">
              {{item.desc}}
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- prototypes -->
    <div class="prototypes">
      <img src="../assets/images/home/prototypes.png" alt="" />
    </div>

    <Footer />
  </div>
</template>
<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
export default {
  metaInfo: {
    title: '东莞市乔斯精密机械有限公司',
    meta: [
      {
        name: 'keywords',
        content: '东莞市乔斯精密机械有限公司,乔斯,精密,机械',
      },
      {
        name: 'description', // 设置页面描述
        content: '品质用心、技术创新、恪守信誉、追求完美',
      },
    ],
  },
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      catList: [
        {
          name: 'Wire EDM',
          desc:
           'It uses continuously moving thin metal wire (called electrode wire) as electrode to remove metal and cut the workpiece by pulse spark discharge.',
          img: require('../assets/images/home/about1.png'),
        },
        {
          name: 'Surface finish',
          desc:
          'It is necessary to select high quality steel and apply corresponding surface treatment technology to improve the service life of the die. Die heat treatment and surface treatment are also the key links to determine the material properties of the fina',
          img: require('../assets/images/home/about2.png'),
        },
        {
          name: '3D printing',
          desc:
            'With a full range of services, we are able to combine 3D printing prototype manufacturing with traditional CNC processing and small batch injection molding to meet the needs of almost every design team.Common hybrid manufacturing equipment integrated',
          img: require('../assets/images/home/about3.png'),
        },
        {
          name: 'CNC lathe',
          desc:
            'CNC machine tools include drilling and tapping machine, parts processing center, mold processing center, horizontal processing center, carving and milling machine, high gloss machine, glass engraving machine, sweeping machine, CNC lathe, Longmen mach',
           img: require('../assets/images/home/about4.png'),
        },
        {
          name: '5-axis CNC milling',
          desc:
            'Need to quickly test out the market with low-volume parts? Or want to create large quantities of production parts? Then you can’t go wrong with our injection molding services.At 3ERP, we produce high-quality prototype moldings from aluminum molds wi',
          img: require('../assets/images/home/about5.png'),
        },
        {
          name: 'CNC milling',
          desc:
            'provides a variety ofprecision CNC machiningservices including milling, turning, EDM (electrical discharge machining) and wire EDM, and surface grinding. With our precision 3-, 4- and 5-axis CNC machining centers, combined with other advanced ca',
          img: require('../assets/images/home/about6.jpg'),
        },
      ],
    }
  },
  methods:{
    toDetail(index){
      this.$router.push({ path: "/service?index=" + index+"&showDetail="+true });
    }
  }
}
</script>
<style scoped>
/* about us */
.about_box {
  background: #fff;
  padding: 50px 0;
}
.about_box .title {
  margin: auto;
  width: 319px;
  height: 89px;
  margin-bottom: 18px;
}
.about_box .content {
  color: #3f4a50;
  font-size: 18px;
  line-height: 30px;
}
/* category */
.category_box {
  padding-bottom: 63px;
  background: #f3f3f3;
}
.category_box li {
  width: 380px;
  background: #fff;
  border-radius: 0 0 24px 24px;
  margin-top: 28px;
}
.category_box li .top {
  width: 100%;
  height: 280px;
  background: #092e48;
}
.category_box li .bottom {
  height: 203px;
  padding: 30px 40px;
}
.category_box li .bottom .name {
  font-size: 18px;
  color: #000;
  margin-bottom: 20px;
}
.category_box li .bottom .detail {
  font-size: 12px;
  color: #8d8d8d;
  line-height: 22px;
  height: 110px;
  overflow: hidden;
}
/* prototypes */
.prototypes {
  margin-bottom: 56px;
}
.prototypes img {
  width: 100%;
  /* height: 412px; */
}
</style>


// WEBPACK FOOTER //
// src/views/home.vue